import React from "react";
import gql from "graphql-tag";
import isEmpty from "lodash/isEmpty";
import { Box, Flex, Text } from "@atoms";
import { FundsPagePaymentListItemFragment } from "./__generated__/FundsPagePaymentListItemFragment";

// == Types ================================================================

interface IProps {
  paymentListItem: FundsPagePaymentListItemFragment;
}

// == Constants ============================================================

FundsPagePaymentListItem.fragments = gql`
  fragment FundsPagePaymentListItemFragment on PaymentRecipient {
    id
    transactionsCount
    amount {
      formatted
      centsAmount
      dollarsAmount
    }
    fundraiser {
      id
      name
    }
  }
`;

// == Component ============================================================

export default function FundsPagePaymentListItem({ paymentListItem }: IProps) {
  if (isEmpty(paymentListItem)) return null;

  const { transactionsCount, amount, fundraiser } = paymentListItem;

  return (
    <Flex justifyContent="space-between" padding={[2, 2, 3]}>
      <Flex flexDirection="column">
        <Box>
          <Text fontSize={[1, 2, 3]}>{fundraiser?.name ? `${fundraiser.name}` : "Team"}</Text>
        </Box>
        <Box>
          <Text fontSize={[0, 1, 2]}>
            {!!transactionsCount && transactionsCount > 1
              ? `${transactionsCount} transactions`
              : `${transactionsCount} transaction`}
          </Text>
        </Box>
      </Flex>
      <Flex alignItems="flex-end" flexDirection="column">
        <Box>
          <Text fontSize={[2, 2, 3]}>{amount?.formatted ?? ""}</Text>
        </Box>
        <Box>
          <Text fontSize={[0, 1, 2]}>Earned</Text>
        </Box>
      </Flex>
    </Flex>
  );
}

// == Styles ===============================================================
